import MessageTypes from './MessageTypes';
import { SECTION_TYPES } from '../../configs/AppConfig';

const initialState = {
  disclosureTitleDescription: {},
  patientTitleDescription: {},
  disclosureTableHeading: [],
  patientTableHeading: [],
  tableHeading: [],
  tabPageTitle: {}
};

export default function messageReducer (state = initialState, action) {
  const {
    type,
    payload
  } = action;
  let newState = { ...state };
  switch (type) {
    case MessageTypes.GET_SECTION_TITLE_DESCRIPTION_SUCCESS:
      if (payload.type === SECTION_TYPES.DISCLOSURE.value) {
        newState.disclosureTitleDescription = { ...payload.content };
      } else {
        newState.patientTitleDescription = { ...payload.content };
      }
      return newState;
    case MessageTypes.GET_TABLE_HEADING_SUCCESS:
      if (payload.type === SECTION_TYPES.DISCLOSURE.value) {
        newState.disclosureTableHeading = [...payload.content];
      } else {
        newState.patientTableHeading = [...payload.content];
      }
      return newState;
    case MessageTypes.GET_TAB_PAGE_TITLE_SUCCESS:
      newState.tabPageTitle = { ...payload };
      return newState;
    default:
      newState = state;
      break;
  }

  // return new state
  return newState;
}
